module.exports = __webpack_public_path__ + "img/file-upload-active.ca613a01.svg";